import BulletinBranding from './bulletin-branding';

export default BulletinBranding;
